<!-- HEADER START -->
<app-header></app-header>
<!-- HEADER END -->

<main class="app-route-content">
  <router-outlet></router-outlet>
</main>

<!-- BUTTON TOP START -->
<button class="scroltop"><span class="fa fa-angle-up  relative" id="btn-vibrate"></span></button>

<!-- LOADING AREA ===== -->
<app-loader></app-loader>

<!-- FOOTER START -->
<app-footer [data]='footerData'></app-footer>
<!-- FOOTER END -->